import { Descendant, Text as SlateText } from 'slate';

const serializeToPlainText = (nodes: Descendant[]): string => nodes.map((node) => {
  if (SlateText.isText(node)) {
    return node.text;
  }
  return serializeToPlainText(node.children);
}).join(' ');

export default serializeToPlainText;